// Dark Theme
import snackmagicImg from "@stadium/ui/src/assets/images/svg/footer/snackmagic.svg";
import swagmagicImg from "@stadium/ui/src/assets/images/svg/footer/swagmagic.svg";
import shopsImg from "@stadium/ui/src/assets/images/svg/footer/shops.svg";

// Light Theme
import snackmagicwhiteImg from "@stadium/ui/src/assets/images/svg/footer/snackmagic-white.svg";
import swagmagicwhiteImg from "@stadium/ui/src/assets/images/svg/footer/swagmagic-white.svg";
import shopswhiteImg from "@stadium/ui/src/assets/images/svg/footer/shops-white.svg";
import {
  BYSTADIUM_MARKETING_URL,
  BYSTADIUM_URL,
  SNACKMAGIC_URL,
  SWAGMAGIC_URL,
} from "@stadium/helpers/app-routes";
import { CONTACT_US, HELP_CENTER_URL } from "@stadium/constants/routes";

const TERMS_OF_USE_LINK_KEY = "terms_of_use";
const COOKIE_PREFERENCES_LINK_KEY = "cookie_preferences";
export const ACCESSIBILITY_SUPPORT_KEY = "accessibility_support";
const NEED_HELP_LINK_KEY = "need_help";
const HELP_CENTER_LINK_KEY = "help_center";
const CONTACT_US_LINK_KEY = "contact_us";
const EXPLORE_FEATURES_LINK_KEY = "explore_features";

export const VISIBLE_LINKS = [
  TERMS_OF_USE_LINK_KEY,
  COOKIE_PREFERENCES_LINK_KEY,
  ACCESSIBILITY_SUPPORT_KEY,
  EXPLORE_FEATURES_LINK_KEY,
  HELP_CENTER_LINK_KEY,
  CONTACT_US_LINK_KEY,
];

export const WHITELABLED_RESTRICTED_LINKS = [EXPLORE_FEATURES_LINK_KEY, CONTACT_US_LINK_KEY];

export const DEFAULT_VISIBLE_LINKS = [
  TERMS_OF_USE_LINK_KEY,
  COOKIE_PREFERENCES_LINK_KEY,
  ACCESSIBILITY_SUPPORT_KEY,
  NEED_HELP_LINK_KEY,
];

export const LINKS = {
  [TERMS_OF_USE_LINK_KEY]: {
    text: "TERMS OF USE",
    link: "https://www.bystadium.com/terms-of-use",
  },
  [COOKIE_PREFERENCES_LINK_KEY]: {
    text: "COOKIE PREFERENCES",
    link: "#",
    target: "_self",
    otherProps: {
      onClick: (e) => {
        e.preventDefault();
        globalThis?.Osano?.cm?.showDrawer("osano-cm-dom-info-dialog-open");
      },
    },
  },
  [ACCESSIBILITY_SUPPORT_KEY]: {
    text: " Accessibility Support",
    target: "_self",
    link: "",
    otherProps: { "data-acsb-custom-trigger": true, onClick: (e) => e.preventDefault() },
  },
  [NEED_HELP_LINK_KEY]: {
    text: "NEED HELP?",
    link: "#",
    target: "_self",
    otherProps: {
      onClick: (e) => {
        e.preventDefault();
        globalThis?.zE?.("messenger", "open");
      },
    },
  },
  [EXPLORE_FEATURES_LINK_KEY]: {
    text: "EXPLORE FEATURES",
    link: BYSTADIUM_MARKETING_URL,
    target: "_self",
  },
  [HELP_CENTER_LINK_KEY]: {
    text: "HELP CENTER",
    link: HELP_CENTER_URL,
  },
  [CONTACT_US_LINK_KEY]: {
    text: "CONTACT US",
    link: CONTACT_US,
  },
};

export const LOGOS = [
  {
    altText: "Snackmagic logo",
    lightModeImg: snackmagicImg,
    darkModeImg: snackmagicwhiteImg,
    url: SNACKMAGIC_URL,
  },
  {
    altText: "Stadium shops logo",
    lightModeImg: shopsImg,
    darkModeImg: shopswhiteImg,
    url: BYSTADIUM_URL,
  },
  {
    altText: "SwagMagic logo",
    lightModeImg: swagmagicImg,
    darkModeImg: swagmagicwhiteImg,
    url: SWAGMAGIC_URL,
  },
];
